// 2ndOpinion AI - Medical Report Analysis Platform
// Azure deployment with OAuth token handling
// DUMMY CHANGE TO TRIGGER FRONTEND DEPLOYMENT
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals'; // Commented out to fix build

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);









